import {Injectable} from '@angular/core';
import {RoutingDemoPageService} from './routing-demo-page-service';
import {ErrorDialogService} from './error-dialog.service';
import {of} from 'rxjs';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, mergeMap, concatMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoutingDatabaseService {
  username: string;
  password: string;

  constructor(private routingDemoPageService: RoutingDemoPageService, private errorDialogService: ErrorDialogService,
              private http: HttpClient) {
  }

  getDBNames(username, password): Observable<any> {
    const tokenRequest = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" ' +
      'xmlns:tok="http://token.security.common.server.platform.spectrum.pb.com/" ' +
      'xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
      '<soapenv:Header/>' +
      '<soapenv:Body xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"> ' +
      '<tok:getAccessToken xmlns="http://token.security.common.server.platform.spectrum.pb.com/"/>' +
      '</soapenv:Body>' +
      '</soapenv:Envelope>';
    const url = this.routingDemoPageService.getFetchTokenURL();
    const headers = {
      Accept: 'application/xml, text/xml, */*, q=0.01',
      Authorization: 'Basic ' + btoa(username + ':' + password),
      'Content-Type': 'text/xml,charset=utf-8;'
    };
    return this.http.post(url, tokenRequest, {headers, responseType: 'text'}).pipe(concatMap(response => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response, 'text/xml');
        const tokenResponse = xmlDoc.getElementsByTagName('token');
        const token = tokenResponse[0].childNodes[0].nodeValue;
        const url2 = this.routingDemoPageService.getFetchDBURL();
        // tslint:disable-next-line:no-shadowed-variable
        const headers = {
          Authorization: 'Bearer ' + token,
        };
        return this.http.get(url2, {headers}).pipe(map(response1 => {
          return response1;
        }));
      }));
    }
}
